import { render, staticRenderFns } from "./fullprojectAutoInspecRepoList.vue?vue&type=template&id=2782736c&"
import script from "./fullprojectAutoInspecRepoList.vue?vue&type=script&lang=js&"
export * from "./fullprojectAutoInspecRepoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports